export default "/images/abstract-grid-dashed-lines.png";